// @flow
import React, { useState } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import FollowButton from 'app/common/react/components/common/User/FollowButton';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import UserImage from 'app/common/react/components/common/UserImage/UserImage';
import { Box } from 'gestalt';
import { type Dispatch } from 'redux';
import { follow, unfollow } from 'app/common/redux/actions/user/follow';
import { track, type TrackingData } from 'app/common/lib/react/analytics';

export type UserType = {|
  email?: string,
  explicitly_followed_by_me?: boolean,
  full_name: string,
  id: string,
  image_key?: string,
  image_medium_url?: string,
  image_small_url?: string,
  is_partner?: boolean,
  role?: string, // TODO: this should probably be an enum
  username: string,
|};

type ReduxDispatchProps = {|
  follow: (id: string) => void,
  unfollow: (id: string) => void,
|};

type OwnProps = {|
  className?: string,
  followedByMe?: boolean,
  isSelf?: boolean,
  logData?: TrackingData,
  showFollow?: boolean,
  showName?: boolean,
  size?: 'medium' | 'smallerMedium' | 'small',
  subtitle?: string,
  title?: string,
  user: UserType,
  viewType: 'thumb',
|};

type Props = {|
  ...OwnProps,
  ...ReduxDispatchProps,
|};

export function User({
  className,
  followedByMe = false,
  isSelf,
  logData,
  showName = false,
  showFollow = false,
  size = 'small',
  subtitle = '',
  title,
  user = {},
  viewType = 'thumb',
}: Props) {
  const [isFollowing, setIsFollowing] = useState<boolean>(user.explicitly_followed_by_me || false);

  const handleFollowClick = () => {
    if (isFollowing) {
      unfollow(user.id);
      setIsFollowing(false);
    } else {
      follow(user.id);
      setIsFollowing(true);
    }

    if (logData) {
      track(PCONST.thrift.EventType.CLICK, logData);
    }
  };

  const { full_name: fullName, username } = user;
  const src = user.image_key || user.image_medium_url || user.image_small_url;

  return (
    <div className={cx('Module', 'User', 'hasText', 'thumb', size, className)}>
      <Box alignItems="center" direction="row" display="flex" marginStart={-1} marginEnd={-1}>
        <Box flex="grow" paddingX={1}>
          <NavigateLink className="profileSource" to={`/${username}/`}>
            <div className="thumbImageWrapper">
              <UserImage fullName={fullName} imageSrc={src} />
            </div>
            {title && <h3 className="title">{title}</h3>}
            {showName && <h4 className="fullname">{fullName}</h4>}
            {subtitle && <div className="subtitle">{subtitle}</div>}
          </NavigateLink>
        </Box>

        {showFollow && (
          <Box paddingX={1}>
            <FollowButton
              handleFollowClick={handleFollowClick}
              isFollowing={isFollowing}
              isSelf={Boolean(isSelf)}
            />
          </Box>
        )}
      </Box>
    </div>
  );
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    follow: (id) => dispatch(follow(id)),
    unfollow: (id) => dispatch(unfollow(id)),
  };
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  mapDispatchToProps,
)(User);
